import styled from 'styled-components';
import {
  TextField,
} from '@mui/material';
import PostAddIcon from '@mui/icons-material/PostAdd';
import MicIcon from '@mui/icons-material/Mic';

import { ReactComponent as StopIcon } from '../../../../assets/icons/stop-icon.svg';
import colors from '../../../../styles/colors';
import Button from '../../../Button';

const DateSelectorContainer = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 10px;
  align-items: center;
`;

const AttachmentButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 8px;
`;

const ConfirmButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 8px;
`;

const ScheduleButton = styled(Button)`
  border-radius: 8px;
  background: ${({ $light }) => ($light ? colors.base.support : colors.base.secondary2)};
  cursor: pointer;
  color: ${({ $light }) => ($light ? colors.base.beta : colors.base.alpha)};
  column-gap: 8px;
  text-transform: none;
  height: 48;
  padding: 10px 14px;
  font-size: 18px;
  line-height: 16px;
  width: fit-content;
  border: 1px solid ${colors.base.beta};
`;

const StyledText = styled.div`
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 12px;
  color: ${colors.base.secondary2};
`;

const StyledButton = styled(Button)`
  background-color: ${colors.shades.secondary4};
  color: ${colors.shades.secondary3};
  cursor: pointer;
  padding: 0 5px;
  height: 32px;
  width: 128px;
  font-size: 14px;
  line-height: 30px;
  font-weight: 500;
  border-radius: 20px;
  border: 1px solid ${colors.shades.secondary6};

  &:hover {
    background-color: ${colors.shades.secondary10};
  }
`;

const StyledFakeButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${colors.shades.secondary4};
  color: ${colors.shades.secondary3};
  cursor: pointer;
  padding: 0 5px;
  height: 32px;
  width: 114px;
  font-size: 14px;
  line-height: 30px;
  font-weight: 500;
  border-radius: 20px;
  border: 1px solid ${colors.shades.secondary6};

  &:hover {
    background-color: ${colors.shades.secondary10};
  }
`;

const StyledTextField = styled(TextField)`
  & .MuiInputBase-root {
    height: 48px;
    width: 196px;
    background: ${colors.base.alpha};
    color: ${colors.base.beta};
    border-radius: 8px;
  }

  & .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {
    border: 1px solid ${colors.shades.secondary7};
  }

  & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border: 1px solid ${colors.shades.secondary7};
  }

  & .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline {
    border: 1px solid ${colors.shades.secondary7};
  }

  & .MuiSvgIcon-root {
    > path {
      fill: ${colors.base.secondary2};
    }
  }
`;

const FileAttachmentIcon = styled(PostAddIcon)`
  > path {
    fill: ${colors.base.secondary2};
  }
`;

const StyledMicIcon = styled(MicIcon)`
  > path {
    fill: ${colors.base.secondary2};
  }
`;

const StyledStopIcon = styled(StopIcon)`
  height: 24px;
  width: 24px;
  color: ${colors.shades.danger1};
  margin-left: 8px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 12px;
`;

const PickerContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const AttachmentsContainer = styled.div`
  display: block;
  align-items: start;
  background: ${colors.base.alpha};
  border-radius: 25px;
  border: 1px solid ${colors.shades.secondary7};
  height: fit-content;
  padding: 8px;
`;

const CenterLoading = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px;
`;

const CheckBoxContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export {
  Container,
  StyledText,
  StyledTextField,
  StyledButton,
  StyledFakeButton,
  AttachmentButtonsContainer,
  AttachmentsContainer,
  CenterLoading,
  FileAttachmentIcon,
  StyledMicIcon,
  StyledStopIcon,
  DateSelectorContainer,
  ConfirmButtonsContainer,
  ScheduleButton,
  PickerContainer,
  CheckBoxContainer,
};
